import React, { ReactElement } from 'react';

import { Sheet } from '../../../../../../mobile/structural/sheet/Sheet';
import { UseSheetReturnType } from '../../../../../../mobile/structural/sheet/hooks/useSheet';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import { Button, FormText } from '@milanote/roma';

type LabelDeleteSheetProps = {
    onDelete: () => void;
    sheetProps: UseSheetReturnType;
};

const LabelDeleteSheet = ({ onDelete, sheetProps }: LabelDeleteSheetProps): ReactElement => {
    const translate = useTranslator('popup', 'labels.edit');

    return (
        <Sheet className="LabelDeleteSheet" {...sheetProps}>
            <Sheet.Overlay />
            <Sheet.Panel>
                <Sheet.Header>
                    <Sheet.Heading>{translate('deleteTitle')}</Sheet.Heading>
                </Sheet.Header>
                <Sheet.Content className="px-3xl pt-lg">
                    <div className="flex flex-col gap-3xl">
                        <FormText align="center" size="lg" color="secondary">
                            {translate('deleteDescription')}
                        </FormText>

                        <div className="pb-6xl flex gap-lg">
                            <Button
                                color="secondary"
                                size="xl"
                                className="flex-1"
                                onClick={() => sheetProps.closeSheet()}
                            >
                                {translate('deleteCancel')}
                            </Button>
                            <Button color="primary-destructive" size="xl" className="flex-1" onClick={onDelete}>
                                {translate('deleteConfirm')}
                            </Button>
                        </div>
                    </div>
                </Sheet.Content>
            </Sheet.Panel>
        </Sheet>
    );
};

export default LabelDeleteSheet;
